module.exports = __webpack_public_path__ + "static/media/Brianna_Workman_Resume.f957baa3.pdf";